// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { Observer } from "mobx-vue";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";
import { reaction } from "mobx";
import { Headline } from "../../../components/headline/Headline";
import { Gallery } from "../../../components/gallery/Gallery";
import { ImageAspectRatio } from "../../../components/image_aspect_ratio/ImageAspectRatio";
import { StoryLink } from "../../common/story_link/StoryLink";
import { Api } from "../../../api";
import { Report } from "../../../common/interfaces/conversionworld/Report";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    Headline,
    Gallery,
    ImageAspectRatio,
    StoryLink,
  },
})
export class ReportsModule extends ModuleBase {
  private reports: Report[] = [];

  public getBackgroundColorFromInstance(instance: object) {
    return this.instance["color"];
  }

  public created() {
    this.loadReports();
  }

  public async loadReports() {
    let ids = this.instance["stories"].map((s) => s["anker"]);
    this.reports = await Api.conversionWorldService.getReports(
      ids,
      this.$store.page.page!.id
    );
  }
}
